import { useQuery } from "react-query";
import { getActiveOfficeDivision } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeDivision = () => {
  return useQuery("GetActiveOfficeDivision", getActiveOfficeDivision, {
    refetchOnWindowFocus: false,
  });
};
